<template>
	<b-card-body>
		<b-row class="mb-3">
			<b-col cols="3">
				<label class="lebeltop">{{ $t('incomeFilter.department')}}</label>
				<multiselect
					v-model="filter.departmentId"
					:options="myDepartments"
					size="sm"
					track-by="id"
					:show-labels="false"
					:allow-empty="true"
					label="name"
					:placeholder="$t('promo-to-product.department')"
					class="multiselect-pricing"
				>
				</multiselect>
			</b-col>
			<b-col sm="2">
				<label class="lebeltop">
					{{ $t('incomeFilter.from')}}</label>
				<b-form-group
					label-size="sm"
					label-for="refName"
					class="required"
				>

					<date-picker v-model="filter.start"
								 lang="ru"
								 size="sm"
								 placeholder="dd-mm-yyyy"
								 valueType="format"
								 format="DD-MM-YYYY"
					></date-picker>
				</b-form-group>
			</b-col>
			<b-col sm="3" style="margin-left: 30px;">
				<label class="lebeltop">
					{{ $t('incomeFilter.to')}}</label>
				<b-form-group
					label-size="sm"
					label-for="refName"
					class="required"
				>

					<date-picker v-model="filter.end"
								 lang="ru"
								 size="sm"
								 placeholder="dd-mm-yyyy"
								 valueType="format"
								 format="DD-MM-YYYY"
					></date-picker>
				</b-form-group>
			</b-col>
			<b-col sm="2">
				<label class="lebeltop">
					<p></p></label>
				<b-form-group
					label-size="sm"
					label-for="refName"
					class="required"
				>
					<b-button @click="getDataByFilter" class="pull-right" variant="primary">{{
						$t('apply') }}
					</b-button>
				</b-form-group>

			</b-col>



		</b-row>

		<b-row>
			<b-col cols="8">
				<h5 v-if="filter.departmentId.name">{{ $t('incomeFilter.department')}} : <span
					class="text-danger">{{ filter.departmentId.name}}</span> <span
					class="text-success">&nbsp;&nbsp;(  {{ filter.start ? filter.start : getYear(true)}} {{ filter.end ? ' - ' + filter.end : '- ' + getYear()}}  )</span>
				</h5>
			</b-col>
		</b-row>

		<b-modal
			v-model="docIncomeCountModal"
			size="lg"
			hide-footer
			:no-close-on-esc="true"
			:no-close-on-backdrop="true"
			:title="currentDocNumber"
		>
			<div class="modal-body">
				<div class="row">
					<table class="table table-striped">
						<thead>
						<tr>
							<th scope="col">#</th>
							<th scope="col">{{ $t('goods.name')}}</th>
							<th scope="col">{{ $t('goods.artikul')}}</th>
							<th scope="col">{{ $t('goods.barcode')}}</th>
							<th scope="col">{{ $t('incomes.create.count')}}</th>
						</tr>
						</thead>
						<tbody>
						<tr v-for="item,index in WhDocModalItems">
							<th scope="row">{{ index + 1}}</th>
							<td>{{ item.itemName.substring(0,30) }}</td>
							<td>{{ item.artikul }}</td>
							<td>{{ item.barcode }}</td>
							<td>{{ item.count }}</td>
						</tr>

						</tbody>
					</table>
				</div>
				<div class="row top mt-3 justify-content-end">
					<div class="col-3">
						<b-button variant="outline-danger" size="sm" block
								  @click="closeModalWindow('docIncomeCountModal')">
							{{$t('actions.cancel')}}
						</b-button>
					</div>

				</div>
			</div>
		</b-modal>
		<b-modal
			v-model="docExtraCostModal"
			size="lg"
			hide-footer
			:no-close-on-esc="true"
			:no-close-on-backdrop="true"
			:title="currentDocNumber"
		>
			<div class="modal-body">
				<div class="row">
					<table class="table table-striped">
						<thead>
						<tr>
							<th scope="col">#</th>
							<th scope="col">{{$t('sidebar.warehouse-management.extra-cost')}}</th>
							<th scope="col">{{$t('incomes.create.price')}}</th>
							<th scope="col">{{$t('comment')}}</th>
						</tr>
						</thead>
						<tbody>
						<tr v-for="extraCost,index in extraCostModalItems">
							<th scope="row">{{ index + 1}}</th>
							<td>{{ extraCost.categoryName }}</td>
							<td>{{ extraCost.cost | currency({symbol: extraCost.currencyName,
								fractionCount:
								2, symbolPosition: 'back'}) }}
							</td>
							<td>{{ extraCost.comment }}</td>
						</tr>

						</tbody>
					</table>
				</div>
				<div class="row top mt-3 justify-content-end">
					<div class="col-3">
						<b-button variant="outline-danger" size="sm" block
								  @click="closeModalWindow('docExtraCostModal')">
							{{$t('actions.cancel')}}
						</b-button>
					</div>

				</div>
			</div>
		</b-modal>


		<hr>
		<b-row v-if="emptyTable" class="mb-3">
			<b-col v-if="Object.keys(whDocList).length === 0" class="myContainer">
				<b-alert variant="danger" v-if="!loading" show>Нет доступных данных</b-alert>
				<div v-if="loading" class="spinner-wrapper">
					<b-spinner variant="primary"></b-spinner>
				</div>
			</b-col>

		</b-row>
		<div v-else>
			<b-row>
				<b-col cols="12">
					<div cols="12">
						<b-alert show>
							{{ $t('alert_table_not_loaded')}}
						</b-alert>
						<div id="chart">
							<apexchart type=bar height=350 :options="chartOptions" :series="series"/>
						</div>
					</div>

				</b-col>
			</b-row>
			<hr>
			<b-row>

				<b-col cols="12">
					<b-button @click="excelExport('tbssslData','Export_Name')" variant="primary" class="pull-right"
							  :disabled="loading">Excel
					</b-button>
				</b-col>
			</b-row>
			<br>
			<b-row>
				<b-col cols="12">
					<div>
						<table class="table b-table table-striped" size="xs" id="tbssslData" width="100%">
							<thead>
							<tr>
								<th rowspan="1" colspan="8" class="text-center">
									{{ $t('incomes.title')}}
								</th>
								<th rowspan="1" colspan="3" class="text-center">
									{{ $t('incomes.create.warehouse')}}
								</th>
							</tr>


							<tr>
								<th class="text-center" scope="col">#</th>
								<th class="text-center" scope="col">{{ $t('incomes.name')}}</th>
								<th class="text-center" scope="col">{{ $t('pricing.date')}}</th>
								<th class="text-center" scope="col">{{ $t('prices.item.sum')}}</th>
								<th class="text-center" scope="col">{{ $t('currency.rate')}}</th>
								<th class="text-center" scope="col">{{ $t('prices.item.sum')}}</th>
								<th class="text-center" scope="col">{{ $t('incomes.create.qty')}}</th>
								<th class="text-center" scope="col">{{
									$t('sidebar.warehouse-management.extra-cost')}}
								</th>
								<th class="text-center" scope="col">{{ $t('incomes.create.qty')}}</th>
								<th class="text-center" scope="col">{{ $t('incomes.create.price')}}</th>
							</tr>
							</thead>
							<tbody class="text-center">
							<tr v-for="item,index in whDocList">
								<td><b>{{ index + 1}}</b></td>
								<td>{{ item.regNumber}}</td>
								<td>{{ item.regDate}}</td>
								<td>{{ item.docIncomeUsd | currency({symbol: item.currency ? item.currency:
									'' ,
									fractionCount: 2,
									symbolPosition: 'back'}) }}
								</td>
								<td class="cls1"> {{ item.currencyRate | currency({symbol:'',
									fractionCount: 2,
									symbolPosition: 'back'}) }}
								</td>
								<td>{{ item.docIncomeUzs | currency({symbol:item.currency ?
									userDepCurrencyName:
									'',
									fractionCount: 2,
									symbolPosition: 'back'}) }}
								</td>
								<td><a href="javascript:void(0);"
									   @click="openModalDocIncomeCount(item.id,'wh-doc',item.regNumber)">{{item.docCount}}</a>
								</td>
								<td><a href="javascript:void(0);"
									   @click="openModalExtraCount(item.id,item.regNumber)">{{
									item.extraCost | currency({symbol: item.currency ? userDepCurrencyName:
									'',
									fractionCount: 2,
									symbolPosition: 'back'}) }} </a></td>
								<td><a href="javascript:void(0);"
									   @click="openModalDocIncomeCount(item.id,'item-status',item.regNumber)">{{
									item.itemCount ? item.itemCount : 0}}</a></td>
								<td>{{ item.itemIncome | currency({symbol: item.currency ?
									userDepCurrencyName:
									'',
									fractionCount: 2,
									symbolPosition: 'back'}) }}
								</td>
							</tr>

							</tbody>
						</table>
						<nav>
							<b-pagination :total-rows="filter.total" :per-page="filter.limit"
										  v-model="filter.page" :prev-text="$t('pagination.prev')"
										  :next-text="$t('pagination.next')" hide-goto-end-buttons/>
						</nav>
					</div>

				</b-col>
			</b-row>
		</div>



	</b-card-body>
</template>

<script>
	import Multiselect from 'vue-multiselect'
	import {mapActions, mapGetters, mapState} from "vuex";
	import Analytics from '../../services/analytics.service';
	import MonitoringService from '../../services/monitoring.service';
	import PosReportService from '../../services/pos.report.service';
	import SaleAnalytics from './SaleAnalytics'

	export default {
		name: 'IncomeAnalytics',
		components: {Multiselect,SaleAnalytics},
		data() {
			return {
				series: [],
				chartOptions: {},
				filter: {
					departmentId: {},
					start: null,
					end: null,
					total: null,
					page: 1,
					limit: 20,
				},
				docIncomeCountModal: false,
				docWhCountModal: false,
				docExtraCostModal: false,
				whDocList: [],
				emptyTable: true,
				loading: false,
				extraCostModalItems: [],
				WhDocModalItems: [],
				currentDocNumber: ''

			}
		},
		methods: {
			...mapActions('departments', ['fetchMyDepartments']),
			getYear(startYear = false) {
				let today = new Date();
				var dd = String(today.getDate()).padStart(2, '0');
				var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
				var yyyy = today.getFullYear();

				if (startYear) {
					today = '01-01-' + yyyy;
				} else {
					today = dd + '-' + mm + '-' + yyyy;
				}


				return today;

			},
			async updateChart(data) {
				let series1 = [];
				let series2 = [];
				let cats = []
				data.forEach(element => {
					cats.push(element.regNumber);
					series1.push(element.docCount);
					series2.push(element.itemCount);
				});

				this.series = [{
					name: this.$t('sidebar.warehouse-management.income'),
					data: series1
				}, {
					name: this.$t('incomes.create.warehouse'),
					data: series2
				}];
				this.chartOptions = {
					plotOptions: {
						bar: {
							horizontal: false,
							columnWidth: '55%',
							endingShape: 'rounded'
						},
					},
					dataLabels: {
						enabled: false
					},
					stroke: {
						show: true,
						width: 2,
						colors: ['transparent']
					},

					xaxis: {
						categories: cats,
					},
					yaxis: {
						title: {
							text: this.$t('sale.kol-vo')
						}
					},
					fill: {
						opacity: 1

					},
					tooltip: {
						y: {
							formatter: function (val) {
								return val
							}
						}
					}
				};
			},
			excelExport(table, name = '') {
				var uri = 'data:application/vnd.ms-excel;base64,',
					template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
					, base64 = function (s) {
						return window.btoa(unescape(encodeURIComponent(s)))
					}
					, format = function (s, c) {
						return s.replace(/{(\w+)}/g, function (m, p) {
							return c[p];
						})
					};
				if (!table.nodeType) table = document.getElementById(table);
				var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML};
				window.location.href = uri + base64(format(template, ctx));

			},
			async getDataByFilter() {
				if(!this.filter.departmentId.id){
					this.$vs.notify({
						title: 'Пожалуйста выберите Отдел',
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
					return false;
				}
				let searchFilter = {};
				searchFilter.depId = this.filter.departmentId.id;
				searchFilter.fromDate = this.filter.start;
				searchFilter.toDate = this.filter.end;
				searchFilter.page = this.filter.page;
				searchFilter.limit = this.filter.limit;
				this.loading = true;
				await Analytics.getAllIncomes(searchFilter).then(response => {
					if (response.data.docList.length > 0) {
						this.whDocList = response.data.docList;

						this.filter.total = response.data.total;
						this.emptyTable = false;
					} else {
						this.whDocList = []
						this.emptyTable = true;
					}
				});
				await this.updateChart(this.whDocList);
				this.loading = false;

			},
			closeModalWindow(name) {
				this[name] = false;
			},
			async openModalExtraCount(id, docNumber) {
				this.docExtraCostModal = true;
				this.currentDocNumber = docNumber;
				await MonitoringService.getExtraCostByDocument(id).then(response => {
					this.extraCostModalItems = response.data;
				})
			},

			async openModalDocIncomeCount(id, method, docNumber) {
				this.docIncomeCountModal = true;
				this.currentDocNumber = docNumber;
				if (method === 'item-status') {
					await PosReportService.getItemStatusItemsByDocId(id).then(response => {
						this.WhDocModalItems = response.data;
					})
				} else {
					await PosReportService.getWhItemsByDocId(id).then(response => {
						this.WhDocModalItems = response.data;
					})
				}

			}
		}
		,
		created() {
			this.fetchMyDepartments();
		}
		,
		computed: {
			...
				mapGetters('departments', [
					'myDepartments'
				]),
			...
				mapState(['userDepCurrencyName']),
		}
		,
		watch: {
			'filter.page':
				{
					handler() {
						this.getDataByFilter();
					}
				}
			,
		}
		,
	}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
	.alert {
		padding: 15px;
	}

	.cls1 {
		mso-number-format: "mso-number-format:\@;"
	}

	.spinner-wrapper {
		position: absolute;
		background: rgba(32, 28, 32, 0.49);
		left: 0;
		right: 0;
		text-align: center;
		top: 0;
		bottom: 0;
		padding-top: 35px;
		z-index: 5;
	}

	.loaderImg {
		position: absolute;
		left: 44%;
		top: 44%;
		z-index: 1;
		border: 6px solid #f3f3f3;
		border-radius: 50%;
		border-top: 6px solid #0092D3;
		border-bottom: 6px solid #0092D3;
		width: 60px;
		height: 60px;
		-webkit-animation: spin 1.6s linear infinite;
		animation: spin 1.6s linear infinite;
	}

	@-webkit-keyframes spin {
		0% {
			-webkit-transform: rotate(0deg);
		}
		100% {
			-webkit-transform: rotate(360deg);
		}
	}

	@keyframes spin {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
</style>
